export enum TaxiCorporationUnbilledOrdersListItemMissingBillings {
  CARGO_TAXI = "CARGO_TAXI",
}

export type TaxiCorporationUnbilledOrdersListItemClient = {
  name: string;
};

export type TaxiCorporationUnbilledOrdersListItem = {
  uuid: string;
  startTime: Date;
  humanId: number;
  isCancelled: boolean;
  rideAddresses: (string | string[])[];
  passengers: string[];
  dispatch: string;
  client: TaxiCorporationUnbilledOrdersListItemClient;
  taxiCorporations: string[];
  drivers: string[];
  externalId: string | null;
  missingTaxiBillings: TaxiCorporationUnbilledOrdersListItemMissingBillings[];
};

type TaxiCorporationUnbilledOrdersList = {
  data: TaxiCorporationUnbilledOrdersListItem[];
  totalCount: number;
};

export default TaxiCorporationUnbilledOrdersList;
